export default function formatPhone(phoneNumber: string | null) {
  if (!phoneNumber) {
    return phoneNumber;
  }

  if (phoneNumber.length === 10) {
    return `${phoneNumber.substring(0, 4)} ${phoneNumber.substring(
      4,
      7
    )} ${phoneNumber.substring(7, 10)}`;
  }
  if (phoneNumber.length === 8) {
    return `${phoneNumber.substring(0, 4)} ${phoneNumber.substring(4, 8)}`;
  }
  return phoneNumber;
}
